import React from 'react';
import './Dashboard.scss';
import { IndicatorWithCarrierAndPeriod } from './IndicatorWithCarrierAndPeriod';
import { DashboardNfeListPage } from '../../dashboardConsultaNfe';
import history from '../../../history';
import { routes } from '../../../constants';
//icones,configuracoes, gestao,roteirizacao,tracking 
import iconGestao from '../../../assets/images/icons/icon_gestao.png';
import iconRoteirizacao from '../../../assets/images/icons/icon_roteirizacao.png';
import iconTracking from '../../../assets/images/icons/icon_tracking.png';
import iconAuditoria from '../../../assets/images/icons/icon_auditoria.png';
import carrierApp from '../../../assets/images/icons/delivery_app.png';
import image_mapa from '../../../assets/images/icons/image_mapa.jpeg';


class Dashboard extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {

    }
    onRedirectPage = (pathPage) => {
        history.push(pathPage);
    }

    render() {

        const { props } = this;
        const moduloGestaoPedidos =
            (
                <div className='class-modulo'>
                    <div className={"card-module"} onClick={() => {
                        history.push(routes.PATH_ORDER_MANAGEMENT);
                    }}>
                        <img className="card-module_icon_gestao" src={iconGestao} />
                        <h3 className='card-module_title'  >{"Gestão de Pedidos"}</h3>
                    </div>

                    {/* indicadores */}
                    <div className='class-indicadores'>

                        <div className='class-indicador' onClick={(e) => this.onRedirectPage(routes.PATH_ORDER_MANAGEMENT)}>
                            <div className='class-indicadores_title'>
                                Pedidos aguardando planejamento
                            </div>
                            <div className='class-indicadores_body indicator-hover'>
                                <div className='class-indicadores_value'>
                                    {props.dashboardParams.pedidosAguaPlanejamento.countPedidosAguaPlanejamento}
                                </div>
                                <div className='class-indicadores_circulo state_2' />
                            </div>
                        </div>
                        {/* Item desabilitado */}
                        <div className='class-indicador_disabled'>
                            <div className='class-indicadores_title_disabled'>

                            </div>
                            <div className='class-indicadores_body_disabled'>
                                <div className='class-indicadores_value_disabled'>

                                </div>
                                <div className='class-indicadores_circulo_disabled state_1_disabled'></div>
                            </div>
                        </div>

                        {/* Item desabilitado */}
                        <div className='class-indicador_disabled'>
                            <div className='class-indicadores_title_disabled'>

                            </div>
                            <div className='class-indicadores_body_disabled'>
                                <div className='class-indicadores_value_disabled'>

                                </div>
                                <div className='class-indicadores_circulo_disabled state_1_disabled'></div>
                            </div>
                        </div>

                        {/* Item desabilitado */}
                        <div className='class-indicador_disabled'>
                            <div className='class-indicadores_title_disabled'>

                            </div>
                            <div className='class-indicadores_body_disabled'>
                                <div className='class-indicadores_value_disabled'>

                                </div>
                                <div className='class-indicadores_circulo_disabled state_1_disabled'></div>
                            </div>
                        </div>

                        {/* <div style={{ height: "100%" }}>
                            ocupa todo o espaco vertical
                        </div> */}

                        <IndicatorWithCarrierAndPeriod
                            carrier={props.dashboardParams.pedidosAguaPlanejamento.carrier}
                            onCarrierClick={props.dashboardParams.pedidosAguaPlanejamento.btnCarrierOnClick}
                            period={props.dashboardParams.pedidosAguaPlanejamento.period}
                            onPeriodClick={props.dashboardParams.pedidosAguaPlanejamento.btnPeriodoOnClick}
                            lookup={props.dashboardParams.pedidosAguaPlanejamento.lookup}
                        />
                    </div>
                </div>
            )

        const moduloRoteirizador =
            (
                <div className='class-modulo'>
                    <div className={"card-module"} onClick={() => {
                        history.push(routes.PATH_SCRIPTWRITER);
                    }}>
                        <img className="card-module_icon" src={iconRoteirizacao} />
                        <h3 className='card-module_title'  >{"Roteirizador"}</h3>
                    </div>

                    {/* indicadores */}
                    <div className='class-indicadores'>

                        <div className='class-indicador' onClick={(e) => this.onRedirectPage(routes.PATH_SCRIPTWRITER)}>
                            <div className='class-indicadores_title'>
                                Pedidos em Planejamento
                            </div>
                            <div className='class-indicadores_body indicator-hover'>
                                <div className='class-indicadores_value'>
                                    {props.dashboardParams.roteirizador.countCargasCriadas || 0}
                                </div>

                                <div className='class-indicadores_circulo state_2'></div>

                            </div>
                        </div>

                        {/* Item desabilitado */}
                        <div className='class-indicador_disabled'>
                            <div className='class-indicadores_title_disabled'>

                            </div>
                            <div className='class-indicadores_body_disabled'>
                                <div className='class-indicadores_value_disabled'>

                                </div>
                                <div className='class-indicadores_circulo_disabled state_1_disabled'></div>
                            </div>
                        </div>


                        {/* Item desabilitado */}
                        <div className='class-indicador_disabled'>
                            <div className='class-indicadores_title_disabled'>

                            </div>
                            <div className='class-indicadores_body_disabled'>
                                <div className='class-indicadores_value_disabled'>

                                </div>
                                <div className='class-indicadores_circulo_disabled state_1_disabled'></div>
                            </div>
                        </div>

                        {/* Item desabilitado */}
                        <div className='class-indicador_disabled'>
                            <div className='class-indicadores_title_disabled'>

                            </div>
                            <div className='class-indicadores_body_disabled'>
                                <div className='class-indicadores_value_disabled'>

                                </div>
                                <div className='class-indicadores_circulo_disabled state_1_disabled'></div>
                            </div>
                        </div>

                        {/* <div style={{ height: "100%" }}>
                            ocupa todo o espaco vertical
                        </div> */}

                        <IndicatorWithCarrierAndPeriod
                            carrier={props.dashboardParams.roteirizador.carrier}
                            onCarrierClick={props.dashboardParams.roteirizador.btnCarrierOnClick}
                            period={props.dashboardParams.roteirizador.period}
                            onPeriodClick={props.dashboardParams.roteirizador.btnPeriodoOnClick}
                            lookup={props.dashboardParams.roteirizador.lookup}
                        />

                    </div>
                </div>
            )

        const moduloEntregasTrasportadoras =
            (
                <div className='class-modulo'>
                    <div className={"card-module"} onClick={() => {
                        history.push(routes.PATH_TRACKING);
                    }}>
                        <img className="card-module_icon" src={iconTracking} />
                        <h3 className='card-module_title'  >{"Entregas Transportadoras"}</h3>
                    </div>

                    {/* indicadores */}
                    <div className='class-indicadores'>
                        {/* Planejadas */}
                        <div className='class-indicador' onClick={(e) => this.onRedirectPage(routes.PATH_TRACKING)}>
                            <div className='class-indicadores_title'>
                                Planejadas
                            </div>
                            <div className='class-indicadores_body indicator-hover'>
                                <div className='class-indicadores_value'>
                                    {props.dashboardParams.deliveriesCarriers.values.countCargasPlanejadas || 0}
                                </div>
                                <div className='class-indicadores_circulo state_3'></div>
                            </div>
                        </div>

                        <div className='class-indicador' onClick={(e) => this.onRedirectPage(routes.PATH_TRACKING)}>
                            <div className='class-indicadores_title'>
                                Em trânsito
                            </div>
                            <div className='class-indicadores_body indicator-hover'>
                                <div className='class-indicadores_value'>
                                    {props.dashboardParams.deliveriesCarriers.values.countCargasTransito || 0}
                                </div>
                                <div className='class-indicadores_circulo state_4'></div>
                            </div>
                        </div>

                        {/* Realizadas */}
                        <div className='class-indicador' onClick={(e) => this.onRedirectPage(routes.PATH_TRACKING)}>
                            <div className='class-indicadores_title'>
                                Realizadas
                            </div>
                            <div className='class-indicadores_body indicator-hover'>
                                <div className='class-indicadores_value'>
                                    {props.dashboardParams.deliveriesCarriers.values.countCargasRealizadas || 0}
                                </div>
                                <div className='class-indicadores_circulo state_2'></div>
                            </div>
                        </div>

                        {/* Atrazadas */}
                        <div className='class-indicador' onClick={(e) => this.onRedirectPage(routes.PATH_TRACKING)}>
                            <div className='class-indicadores_title'>
                                Atrasadas
                            </div>
                            <div className='class-indicadores_body indicator-hover'>
                                <div className='class-indicadores_value'>
                                    {props.dashboardParams.deliveriesCarriers.values.countCargasAtrasadas || 0}
                                </div>
                                <div className='class-indicadores_circulo state_1'></div>
                            </div>
                        </div>



                        {/* <div style={{ height: "100%" }}>
                            ocupa todo o espaco vertical
                        </div>
                         */}
                        <IndicatorWithCarrierAndPeriod
                            carrier={props.dashboardParams.deliveriesCarriers.carrier}
                            onCarrierClick={props.dashboardParams.deliveriesCarriers.btnCarrierOnClick}
                            period={props.dashboardParams.deliveriesCarriers.period}
                            onPeriodClick={props.dashboardParams.deliveriesCarriers.btnPeriodoOnClick}
                            lookup={props.dashboardParams.deliveriesCarriers.lookup}
                        />

                    </div>
                </div>
            )
        const moduloEntregasApp =
            (
                <div className='class-modulo'>
                    <div className={"card-module"} onClick={() => {
                        history.push("/delivery_management/app");
                    }}>
                        <img className="card-module_icon" src={carrierApp} />
                        <h3 className='card-module_title'  >{"Entregas App"}</h3>
                    </div>

                    {/* indicadores */}
                    <div className='class-indicadores'>
                        {/* Planejadas */}
                        <div className='class-indicador'>
                            <div className='class-indicadores_title'>
                                Planejadas
                            </div>
                            <div className='class-indicadores_body indicator-hover'>
                                <div className='class-indicadores_value'>
                                    {props.dashboardParams.deliveriesByApp.values.countCargasPlanejadas || 0}
                                </div>
                                <div className='class-indicadores_circulo state_3'></div>
                            </div>
                        </div>

                        <div className='class-indicador' onClick={(e) => this.onRedirectPage(routes.PATH_DELIVERY_MANAGEMENT_APP)}>
                            <div className='class-indicadores_title'>
                                Em trânsito
                            </div>
                            <div className='class-indicadores_body indicator-hover'>
                                <div className='class-indicadores_value'>
                                    {props.dashboardParams.deliveriesByApp.values.countCargasTransito || 0}
                                </div>
                                <div className='class-indicadores_circulo state_4'></div>
                            </div>
                        </div>

                        {/* Realizadas */}
                        <div className='class-indicador' onClick={(e) => this.onRedirectPage(routes.PATH_DELIVERY_MANAGEMENT_APP)}>
                            <div className='class-indicadores_title'>
                                Realizadas
                            </div>
                            <div className='class-indicadores_body indicator-hover'>
                                <div className='class-indicadores_value'>
                                    {props.dashboardParams.deliveriesByApp.values.countCargasRealizadas || 0}
                                </div>
                                <div className='class-indicadores_circulo state_2'></div>
                            </div>
                        </div>

                        {/* Ocorrências */}
                        <div className='class-indicador' onClick={(e) => this.onRedirectPage(routes.PATH_DELIVERY_MANAGEMENT_APP)}>
                            <div className='class-indicadores_title'>
                                Ocorrências
                            </div>
                            <div className='class-indicadores_body indicator-hover'>
                                <div className='class-indicadores_value '>
                                    {props.dashboardParams.deliveriesByApp.values.countOcorrencias || 0}
                                </div>
                                <div className='class-indicadores_circulo state_1'></div>
                            </div>
                        </div>


                        {/* <div style={{ height: "100%" }}>
                            ocupa todo o espaco vertical
                        </div> */}

                        <IndicatorWithCarrierAndPeriod
                            carrier={props.dashboardParams.deliveriesByApp.carrier}
                            onCarrierClick={props.dashboardParams.deliveriesByApp.btnCarrierOnClick}
                            period={props.dashboardParams.deliveriesByApp.period}
                            onPeriodClick={props.dashboardParams.deliveriesByApp.btnPeriodoOnClick}
                            lookup={props.dashboardParams.deliveriesByApp.lookup}
                        />

                    </div>
                </div>
            )
        const moduloAuditoria =
            (
                <div className='class-modulo'>
                    <div className={"card-module"} onClick={() => {
                        history.push(routes.PATH_AUDIT);
                    }}>
                        <img className="card-module_icon" src={iconAuditoria} />
                        <h3 className='card-module_title'  >{"Auditoria"}</h3>
                    </div>

                    {/* indicadores */}
                    <div className='class-indicadores'>
                        {/* CT-e Recebidos */}
                        <div className='class-indicador' onClick={(e) => this.onRedirectPage(routes.PATH_AUDIT)}>
                            <div className='class-indicadores_title'>
                                CT-e Recebidos
                            </div>
                            <div className='class-indicadores_body indicator-hover'>
                                <div className='class-indicadores_value'>
                                    {props.dashboardParams.auditoria.values.countCteRecebidos || 0}
                                </div>
                                <div className='class-indicadores_circulo state_2'></div>
                            </div>
                        </div>

                        {/*  CT-e Divergentes */}
                        <div className='class-indicador' onClick={(e) => this.onRedirectPage(routes.PATH_AUDIT)}>
                            <div className='class-indicadores_title'>
                                CT-e Divergentes
                            </div>
                            <div className='class-indicadores_body indicator-hover'>
                                <div className='class-indicadores_value'>
                                    {props.dashboardParams.auditoria.values.countCteDivergentes || 0}
                                </div>
                                <div className='class-indicadores_circulo state_1'></div>
                            </div>
                        </div>

                        {/* Item desabilitado */}
                        <div className='class-indicador_disabled'>
                            <div className='class-indicadores_title_disabled'>

                            </div>
                            <div className='class-indicadores_body_disabled'>
                                <div className='class-indicadores_value_disabled'>

                                </div>
                                <div className='class-indicadores_circulo_disabled state_1_disabled'></div>
                            </div>
                        </div>

                        {/* Item desabilitado */}
                        <div className='class-indicador_disabled'>
                            <div className='class-indicadores_title_disabled'>

                            </div>
                            <div className='class-indicadores_body_disabled'>
                                <div className='class-indicadores_value_disabled'>

                                </div>
                                <div className='class-indicadores_circulo_disabled state_1_disabled'></div>
                            </div>
                        </div>


                        {/* <div style={{ height: "100%" }}>
                            /* ocupa todo o espaco vertical 
                        </div> */}

                        <IndicatorWithCarrierAndPeriod
                            carrier={props.dashboardParams.auditoria.carrier}
                            onCarrierClick={props.dashboardParams.auditoria.btnCarrierOnClick}
                            period={props.dashboardParams.auditoria.period}
                            onPeriodClick={props.dashboardParams.auditoria.btnPeriodoOnClick}
                            lookup={props.dashboardParams.auditoria.lookup}
                        />

                    </div>
                </div>
            )
        return (
            <div>

                <div className="p-grid lx-dashboard">

                    <div className="p-grid lx-dashboard__panel">
                        <div className="lx-dashboard__panel-header">
                            Modulos
                        </div>
                        <div className="panel-cards-modules">
                            {moduloGestaoPedidos}
                            {moduloRoteirizador}
                            {moduloEntregasTrasportadoras}
                            {moduloEntregasApp}
                            {moduloAuditoria}
                        </div>
                    </div>




                    <div className="p-grid" style={{ marginLeft: "-3px", marginTop: "100px" }}>
                        <div className="lx-dashboard__panel-header">
                            Informações de Nota Fiscal
                        </div>
                        <div className="lx-dashboard__panel-cards">
                            <DashboardNfeListPage></DashboardNfeListPage>
                        </div>
                    </div>


                </div >


            </div>

        )
    }
};

export default Dashboard;